module.exports = __webpack_public_path__ + "img/service-express-figure.5a73f1c.webp";